import { Link, useLocalSearchParams } from "expo-router";
import { useMemo } from "react";
import { StyleSheet, Text, View } from "react-native";

import { space, textStyle } from "@passfirst/ui";

import { Button } from "../../src/components/button";
import { type Colors, useColors } from "../../src/theme";

export default function CheckoutCancelConfirmed(): JSX.Element {
  const params = useLocalSearchParams<{ provider?: string }>();
  const isMock = params.provider === "mock";
  const colors = useColors();
  const styles = useMemo(() => makeStyles(colors), [colors]);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Subscription cancelled</Text>
      <Text style={styles.body}>
        Your subscription has been cancelled. You'll keep access until the
        current billing period ends, then drop back to the free tier.
      </Text>
      {isMock ? (
        <Text style={styles.devNote}>
          (dev) Mock provider — no real Stripe activity. Purchase row was
          flipped to EXPIRED.
        </Text>
      ) : null}
      <Link href="/" asChild>
        <Button label="Back home" />
      </Link>
    </View>
  );
}

function makeStyles(colors: Colors) {
  return StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
    alignItems: "center",
    justifyContent: "center",
    padding: space[6],
    gap: space[4],
  },
  title: { ...textStyle.h2, color: colors.heading },
  body: {
    ...textStyle.body,
    color: colors.textSecondary,
    textAlign: "center",
    maxWidth: 480,
  },
  devNote: {
    ...textStyle.caption,
    color: colors.textMuted,
    fontStyle: "italic",
  },
  });
}
